// @flow
import React, { Component } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';
import { Text } from 'trpc-react-native-ui';
import Flag from './Flag';
import type { CountryType } from '../../../config/iddCountries';

export default class CountryRow extends Component<Props> {
  shouldComponentUpdate() {
    return false;
  }

  selectCountry = () => this.props.onSelect(this.props.country);

  render() {
    const { country } = this.props;
    return (
      <TouchableOpacity style={styles.line} onPress={this.selectCountry} activeOpacity={0.6}>
        <Flag alpha3={country.id} style={styles.flag} />
        <Text style={styles.name}>{country.name}</Text>
      </TouchableOpacity>
    );
  }
}

const styles = StyleSheet.create({
  line: {
    flex: 1,
    flexDirection: 'row',
    paddingLeft: 20,
    marginBottom: 10,
    height: 26,
  },
  name: {
    marginLeft: 35,
    alignSelf: 'center',
    alignItems: 'center',
  },
  flag: {
    width: 5,
    height:5
  },
});

type Props = {
  country: CountryType,
  onSelect: Function,
};
